import React, { useEffect , useState } from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { Button} from 'reactstrap';
import { pdfjs } from "react-pdf";

import { ModalConstructor, SpinnerConstructor } from '../../../../shared/components';
import ModalVisualizadorPdf from './ModalVisualizadorPdf';
import { VinculosAPI } from '../../../../shared/http-requests';
import { connect, useSelector } from 'react-redux';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

/**
 *
 * author: Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param {Object} props - Propriedades do componente.
 * @param {number|null} [props.codAcervo=null] - Código do acervo.
 * @param {number|null} [props.seqParagrafo=null] - Sequência do parágrafo.
 * @param {string|null} [props.urlPdf=null] - URL do PDF.
 * @param {string|null} [props.descricao=null] - Descrição do PDF.
 * @param {boolean} [props.pdfFromServer=false] - Indica se o PDF vem do servidor.
 * @param {boolean} [props.isRestricted=false] - Indica se o PDF é restrito.
 * @param {boolean} [props.isRestrictedOnce=false] - Indica se a restrição é única.
 * @param {Function} [props.setIsOpenViewPdfRestrictedOnce] - Função para definir se o modal restrito está aberto.
 * @param {boolean} [props.isOpen=false] - Indica se o modal de visualização está aberto.
 * @param {string|null} [props.linkRestrito=null] - Link restrito para o PDF.
 * @returns {JSX.Element}
 * @constructor
 */
const VisualizadorPdfV2 = (props) => {
    const {t} = useTranslation();
    const [modalViewPdfOpen, setmodalViewPdfOpen] = useState(false);
    const [loadingGetLink, setLoadingGetLink] = useState(false);
    const [pdfLink, setPdfLink] = useState('');

    const userRx = useSelector(
        state => state.auth.user || state.authPersist.user,
    );



    const {
                codAcervo = null,
                seqParagrafo = null,
                urlPdf = null,
                descricao = null,
                pdfFromServer =  false ,
                isRestricted = false,
                isRestrictedOnce = false,
                setIsOpenViewPdfRestrictedOnce,
                isOpen = false,
                linkRestrito = null
    } = props;


    useEffect(() => {
        if(isRestrictedOnce && linkRestrito){
            setmodalViewPdfOpen(true)
            setPdfLink(linkRestrito)
        }
    }, [linkRestrito, isRestrictedOnce]);

    useEffect(() => {
        if(isOpen && isRestrictedOnce){
            setmodalViewPdfOpen(true)
        }
    }, [isOpen, isRestrictedOnce]);


    /**
     * quando o arquivo vem do servidor monta o link
     */
    useEffect(() => {
        if(pdfFromServer && codAcervo && seqParagrafo && descricao)
            setPdfLink(`/vinculos/publico/${codAcervo}/seq/${seqParagrafo}/${descricao}`);
    }, [pdfFromServer, codAcervo, seqParagrafo, descricao]);


    /**
     * Arquivo com acesso restrito
     */
    useEffect(() => {
        if(!isRestricted && urlPdf)
            setPdfLink(urlPdf)
    }, [urlPdf])

    const handleClickViewPdf = async() => {
        if(isRestricted){
            setLoadingGetLink(true)
            VinculosAPI.acessarLinkAcessoRestrito(codAcervo, seqParagrafo, userRx?.login).then((response) => {
                const { data } = response;
                setPdfLink(data)
                setmodalViewPdfOpen(true)
                setLoadingGetLink(false)
            }).catch((error) => {
                console.log(`Error on get link`, error)
                setLoadingGetLink(false)
            })
            return ;
        }

        setmodalViewPdfOpen(true)
    }


    useEffect(() => {
        console.log({
            isOpen,
            isRestricted,
            isRestrictedOnce
        })
        if(isOpen && (isRestricted || isRestrictedOnce)){
                setLoadingGetLink(true)
                VinculosAPI.acessarLinkAcessoRestrito(codAcervo, seqParagrafo, userRx?.login).then((response) => {
                    const { data } = response;
                    setPdfLink(data)
                    setmodalViewPdfOpen(true)
                    setLoadingGetLink(false)
                }).catch((error) => {
                    console.log(`Error on get link`, error)
                    setLoadingGetLink(false)
                })
        }
    }, [isRestricted, isRestrictedOnce, isOpen]);


    return (
        <div className="inline">
            {
                loadingGetLink ? (
                    <ModalConstructor open size="xs">
                        <div className="p-4 text-center">
                            {loadingGetLink && (
                                <div>
                                    <SpinnerConstructor
                                        visible
                                        height={60}
                                        width={60}
                                        className="apergamum"
                                    />
                                    <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('Aguarde')}
                                    </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </ModalConstructor>
                ) : pdfLink ? (<ModalVisualizadorPdf
                    urlLink={pdfLink}
                    acervo={codAcervo}
                    isOpen={modalViewPdfOpen}
                    setIsOpen={setmodalViewPdfOpen}
                    onClosed={() => {
                        if(isRestrictedOnce)
                            setIsOpenViewPdfRestrictedOnce(null)
                    }}
                    descricao={descricao}
                    title={(isRestricted || isRestrictedOnce) ? t('AcessoRestrito') :  descricao} />) :   ''
            }

            {
                !isRestrictedOnce ? <Button className="branco hover hpreto bkverde px-2 py-1 rad5 click sverde b-none" onClick={handleClickViewPdf} title={t('AcessarMaterial')}>
                    <FontAwesomeIcon icon={["far","file-pdf"]} className="s15"/>
                </Button> : ''
            }

        </div>
    );
}


export default VisualizadorPdfV2;
